import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLibrary, useModal } from 'hooks';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

import { RootState } from 'redux/reducers/type';

import {
  Button,
  CircularProgress,
  Grid,
  Hidden,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core';

import {
  SearchCondition,
  LibraryStatus,
  AvailableDownloadStatus,
  STORAGE_URL,
} from 'commons/constants/KeyFlowConstants';

import LibraryParamVO from 'commons/vo/param/LibraryParamVO';
import { SortType, AscType } from 'commons/constants/type';
import TimeCode from 'commons/utils/TimeCode';
import { timeFormat, assetWithToken } from 'commons/utils/commonUtil';

import ThumbnailLoading from 'asset/thumbnail/thumb_loading.gif';
import ThumbnailDefault from 'asset/thumbnail/thumb_default.jpg';

import { CancelIcon, DownloadIcon } from 'asset/images';

import { useStyles } from 'components/Library/styles';
import { Pagination } from 'components/Pagination';
import { LibrarySelect } from 'components/Select';
import Library from 'components/Library/Library';
import MediaconvertJob from 'components/Library/MediaconvertJob';
import { Loading } from 'components/VideoPlayer';

function LibraryHeader() {
  const classes = useStyles();
  return (
    <>
      <div className={clsx(classes.container, classes.tableHeader)}>
        <div className={clsx(classes.tableColumn, classes.thumbnailColumn)}>
          <Typography>썸네일</Typography>
        </div>
        <div>
          <div className={clsx(classes.tableColumn, classes.contentsColumn)}>
            <Typography>콘텐츠 명</Typography>
          </div>
          <div className={clsx(classes.tableColumn, classes.fileColumn)}>
            <Typography>파일 정보</Typography>
          </div>
          <div className={clsx(classes.tableColumn, classes.dateOfReqeustColumn)}>
            <Typography>요청 일시</Typography>
          </div>
          <div className={clsx(classes.tableColumn, classes.dateOfTaskColumn)}>
            <Typography>작업 시간</Typography>
          </div>
          <div className={clsx(classes.tableColumn, classes.statusColumn)}>
            <Typography>상태</Typography>
          </div>
        </div>
        <div className={clsx(classes.tableColumn, classes.downloadColumn)}>
          <Typography>다운로드</Typography>
        </div>
      </div>
    </>
  );
}

function LibraryList() {
  const classes = useStyles();

  const { isLoading, libraryList, jobList, libraryCount, waitingCount, pagination } = useSelector(
    (state: RootState) => state.library,
  );

  const { onCloseModal } = useModal();
  const { onRequestLibraryList } = useLibrary();

  const [page, setPage] = useState<number>(0);
  const [sort, setSort] = useState<SortType>(SearchCondition.Sort.DATE_OF_CREATED);
  const [orderBy, setOrderBy] = useState<AscType>(SearchCondition.Asc.DESC);

  useEffect(() => {
    const param = new LibraryParamVO({
      retr: 10,
      sort: sort,
      page: page,
      asc: orderBy,
    });
    onRequestLibraryList(param);
  }, [onRequestLibraryList, page, sort, orderBy]);

  const onChangePage = useCallback(page => {
    setPage(page);
  }, []);

  const onChangeSort = useCallback((sort: SortType) => {
    setSort(sort);
  }, []);

  const onChangeOrderBy = useCallback((asc: AscType) => {
    setOrderBy(asc);
  }, []);

  // 보관함 리스트 요청 function
  const onHandlerRequestList = useCallback(() => {
    const param = new LibraryParamVO({
      retr: 10,
      sort,
      page: 0,
      asc: orderBy,
    });

    onRequestLibraryList(param);
  }, [onRequestLibraryList, sort, page, orderBy]);

  return (
    <>
      <Grid container className={classes.toolbar}>
        <Grid item xs={12} lg={3} className={clsx(classes.titleContainer)}>
          <p>보관함</p>
        </Grid>
        <Grid item xs={12} lg={9} className={classes.inputContainer}>
          <LibrarySelect
            sort={sort}
            asc={orderBy}
            onChangeAsc={onChangeOrderBy}
            onChangeSort={onChangeSort}
          />
          <button
            className={classes.refreshButton}
            onClick={onHandlerRequestList}
            disabled={isLoading}
          >
            <div>
              새로고침
              <img
                src={CancelIcon}
                className={clsx({
                  [classes.isRefreshing]: isLoading,
                })}
              ></img>
            </div>
          </button>
        </Grid>
      </Grid>
      <LibraryHeader />

      <div className={classes.tableBody}>
        {/* {jobList.map((job, index) => (
          <MediaconvertJob key={job.Id || `index_${index}`} job={job} />
        ))} */}
        {libraryList.map(library => (
          <Library library={library} />
        ))}
      </div>
      <Pagination pagination={pagination} onChangePage={onChangePage} />
    </>
  );
}

export default LibraryList;
